import BaseService from "./BaseService";

class EventTmpService extends BaseService {

  constructor(prefix) {
    super(prefix);
  }
}

export default new EventTmpService('event-tmps');